import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "page-modal",
  "use": "page-modal-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"page-modal\"><path fill-rule=\"evenodd\" d=\"M13 22v-6h3l-4-4-4 4h3v6H5.99C4.89 22 4 21.1 4 20l.01-16c0-1.1.89-2 1.99-2h8l6 6v12c0 1.1-.9 2-2 2h-5Zm0-18.5L18.5 9H13V3.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol